var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33334 3.99984H0.666672V15.6665C0.666672 16.5832 1.41667 17.3332 2.33334 17.3332H14V15.6665H2.33334V3.99984ZM15.6667 0.666504H5.66667C4.75001 0.666504 4.00001 1.4165 4.00001 2.33317V12.3332C4.00001 13.2498 4.75001 13.9998 5.66667 13.9998H15.6667C16.5833 13.9998 17.3333 13.2498 17.3333 12.3332V2.33317C17.3333 1.4165 16.5833 0.666504 15.6667 0.666504ZM14.8333 8.1665H6.50001V6.49984H14.8333V8.1665ZM11.5 11.4998H6.50001V9.83317H11.5V11.4998ZM14.8333 4.83317H6.50001V3.1665H14.8333V4.83317Z",
    fill: "#273137"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadIcon);
export default __webpack_public_path__ + "static/media/readIcon.574c7174ae300056a0e48460058ff9f6.svg";
export { ForwardRef as ReactComponent };